<template>
  <div>
    <v-form v-model="valid" ref="mainForm">
      <div v-for="(item, index) in regroupements" :key="item.id">
        <v-card
          v-show="item.visible"
          class="mb-3 pa-4 pt-12 pt-sm-4"
          max-width="600"
          outlined
          :class="{ isError: !valids[index] }"
        >
          <div class="mt-6">
            <v-form :ref="`iteratorForm_${index}`" v-model="valids[index]">
              <h3>{{ item.categorieEmploi.text }}</h3>
              <opq-text-field
                :opq-if="item.visible"
                code="nombre-heures"
                v-model="item.totalHeures"
                :live="liveSasRegroupementDeTravail(24303, item)"
                @eudo-updated="calculTotal"
                isNumber
              ></opq-text-field>
            </v-form>
          </div>
        </v-card>
      </div>
      <v-card v-if="total" class="mb-3 pa-4 pt-12 pt-sm-4" max-width="600" outlined>
        <div class="mt-6">
          <h3>{{ total.categorieEmploi.text }}</h3>
          <opq-text-field
            ref="totalHeures"
            code="nombre-heures"
            v-model="total.totalHeures"
            disabled
            :live="liveSasRegroupementDeTravail(24303, total)"
          ></opq-text-field>
        </div>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import FormHybrid from "@/mixins/FormHybrid"
import { bus } from "@/plugins/bus"
import { Api, Queue } from "@/plugins/api"

export default {
  mixins: [CataloguesHelper, FormHybrid],
  props: {
    sas: { type: Object, required: true },
  },
  data() {
    return {}
  },
  created() {
    bus.$on("refresh-regroupements-de-travail", this.displayRegroupements)
  },
  mounted() {
    // identifie les fiches à afficher/masquer
    this.displayRegroupements()

    // rempli le total à l'ouverture
    this.calculTotal()
  },
  computed: {
    total() {
      return this.sas.regroupementsDeTravail?.find((item) => item.categorieEmploi.code === "0")
    },
    regroupements() {
      if (!this.sas.regroupementsDeTravail?.length) {
        return []
      }

      // clone le tableau, tri ASC et retire le total
      const groups = [...this.sas.regroupementsDeTravail].sort(
        (a, b) => a.categorieEmploi.code - b.categorieEmploi.code
      )

      return groups.slice(1)
    },
  },
  methods: {
    liveSasRegroupementDeTravail(cle, item) {
      return { endpoint: "sas-regroupements-de-travail", cle: cle, fileId: item.id }
    },
    estTypeEmploi(item, type) {
      return this.getCatalogueCodeById(2902, item.typeDEmploi) === type
    },
    estRetraite() {
      return this.estCategorie(15)
    },
    estCategorie(codeCategorie) {
      return this.getCatalogueCodeById(11124, this.sas.sasInscriptionAuTableauRegistre.typeDeCotisation) == codeCategorie
    },
    calculTotal() {
      this.$refs.totalHeures?.setValue(
        this.regroupements.reduce((acc, item) => acc + (parseInt(item.totalHeures) | 0), 0).toString()
      )
    },
    // gère l'affichage des regroupements suivant si il y a une adresse avec un milieu de travail correspondant
    displayRegroupements() {

      if (!this.sas.regroupementsDeTravail?.length) {
        return
      }

      // liste les milieux de travail des adresses
      const milieux = []
      const estRetraite = this.estRetraite()
      let hasPratiquePrivee = false

      this.sas.employeurs
        .filter((item) => !item.inactif)
        .filter((item) => !item.suspenduTemporairement)
        .forEach((item) => {
          if (this.estTypeEmploi(item, "Pri")) {
            hasPratiquePrivee = true
          }

          if (item.milieuTravail1) {
            milieux.push(item.milieuTravail1)
          }
        })

      // recherche des regroupements
      const regroupements = []

      // si le type d'emploi est Pratique privée
      // on ajoute le regroupement "4 - Pratique privée, cabinet privé, entreprise privée" à la liste
      if (hasPratiquePrivee) {
        const codePratiquePrivee = "4"
        regroupements.push(codePratiquePrivee)
      }

      for (let milieu of milieux) {
        const code = this.getCatalogueCodeById(431, milieu)

        const codeGroupe = code.split("-").slice(-1)[0]

        if (regroupements.indexOf(codeGroupe) === -1) {
          regroupements.push(codeGroupe)
        }
      }

      // gestion affichage
      this.sas.regroupementsDeTravail.forEach((item) => {
        // total ou regroupement référencé dans une adresse
        const shouldBeVisible = !estRetraite &&
          (item.categorieEmploi.code === "0" || regroupements.indexOf(item.categorieEmploi.code) !== -1)

        if (shouldBeVisible === item.visible) {
          return
        }

        item.totalHeures = null
        item.visible = shouldBeVisible

        // synchro case à cocher visible
        Queue.enqueue(() => {
          const live = this.liveSasRegroupementDeTravail(24306, item)
          return Api.post(live.endpoint, {
            fileId: live.fileId,
            cle: live.cle,
            value: item.visible,
          })
        })
      })
    },
  },
}
</script>

<style></style>